import { Component, OnInit, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { PortfolioManagement } from '../../../shared/models/portfolioManagement.model';
import { CollectionManagement } from '../../../shared/models/collectionManagement.model';
import { CollectionManagementResult } from '../../../shared/models/collectionManagementResult.model';
import { PortfolioState } from '../../../shared/models/portfolioState.model';

import { PortfolioService } from '../../../shared/_services/portfolio.service';
import { AuthenticationService } from '../../../shared/_services/authentication.service';
import { DocumentSource } from '../../../shared/models/documentSource.model';
import { User } from '../../../shared/models/user.model';

import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { MyFormatter } from '../../../shared/_services/dateformat.service';

@Component({
  selector: 'app-policy-detail',
  templateUrl: './policy-detail.component.html',
  styleUrls: ['./policy-detail.component.css'],
  providers: [{ provide: NgbDateParserFormatter, useClass: MyFormatter }]
})
export class PolicyDetailComponent implements OnInit {

  @Input() policy: PortfolioManagement;
  @Input() collectionManagementResults: CollectionManagementResult[] = [];
  @Input() collectionManagementResultsActive: CollectionManagementResult[] = [];
  @Input() portfolioStates: PortfolioState[] = [];
  @Input() documentSources: DocumentSource[] = [];
  @Output() updateTables = new EventEmitter();
  managementForm: FormGroup;
  gestion: CollectionManagement = new CollectionManagement();
  lastManagement: CollectionManagement;
  idUser: number;
  showIcon: boolean = false;
  hideAll: boolean = true;
  lockFields: boolean = false;
  currentField: any;
  disableFields: boolean = false;
  currentUser: User;

  FieldDocumentType: boolean = false;
  FieldDocumentNumber: boolean = false;
  FieldValue: boolean = false;
  FieldDate: boolean = false;
  
  error: string;
  get f() { return this.managementForm.controls; }

  constructor(private portfolioService: PortfolioService,
    private _authenService: AuthenticationService,
    private formBuilder: FormBuilder) {
    this._authenService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
    this.disableFields = this.policy.blockManagement;
    // construcción de formulario de registro de gestiones
    this.managementForm = this.formBuilder.group({
      managementResult: ['', Validators.required],
      documentSource: ['',],
      document: ['',],
      value: ['',],
      date: ['',],
      managementObservation: ['', Validators.required],
      replayManagement: ['',]
    });
    
    //// petición de estados de póliza
    //this.portfolioService.getPortfolioState()
    //  .subscribe(portfolioState => this.portfolioStates = portfolioState);

    // ordenamiento de tabla de gestiones 
    if (this.policy) {
      this.policy.managementList.sort((a, b) => {
        return (+new Date(b.managementDate)) - (+new Date(a.managementDate));
      });
    }

    //// petición de estados y resultados de gestiones
    //this.portfolioService.getCollectionResult()
    //  .subscribe(collectionResult => {
    //    this.collectionManagementResults = collectionResult;
    //    this.collectionManagementResultsActive = collectionResult.filter(x => x.isActive == true);
    //  });

    // adición de nuevos campos según id de estado
    this.f.managementResult.valueChanges
      .subscribe(idManagementResult => {
        if (this.f.managementResult.valid) {
          this.FieldDocumentType = this.collectionManagementResults.find(u => u.idCollectionManagementResult == idManagementResult).fieldDocumentType;
          this.FieldDocumentNumber = this.collectionManagementResults.find(u => u.idCollectionManagementResult == idManagementResult).fieldDocumentNumber;
          this.FieldValue = this.collectionManagementResults.find(u => u.idCollectionManagementResult == idManagementResult).fieldValue;
          this.FieldDate = this.collectionManagementResults.find(u => u.idCollectionManagementResult == idManagementResult).fieldDate;

          if (this.FieldDocumentType) {
            this.f.documentSource.setValidators([Validators.required]);
            this.f.documentSource.updateValueAndValidity();
          } else {
            this.f.documentSource.clearValidators();
            this.f.documentSource.updateValueAndValidity();
          }

          if (this.FieldDocumentNumber) {
            this.f.document.setValidators([Validators.required]);
            this.f.document.updateValueAndValidity();
          } else {
            this.f.document.clearValidators();
            this.f.document.updateValueAndValidity();
          }

          if (this.FieldValue) {
            this.f.value.setValidators([Validators.required]);
            this.f.value.updateValueAndValidity();
          } else {
            this.f.value.clearValidators();
            this.f.value.updateValueAndValidity();
          }

          if (this.FieldDate) {
            this.f.date.setValidators([Validators.required]);
            this.f.date.updateValueAndValidity();
          } else {
            this.f.date.clearValidators();
            this.f.date.updateValueAndValidity();
          }
          
        }
      });

    //// petición de tipos de documento 
    //this.portfolioService.getDocumentSource()
    //  .subscribe(documentSource => this.documentSources = documentSource);
    
  }

  get isCoordinator() {
    return this.currentUser && this.currentUser.fkUserRole === 2;
  }
  get isAnalyst() {
    return this.currentUser && this.currentUser.fkUserRole === 3;
  }
  get isAssistant() {
    return this.currentUser && this.currentUser.fkUserRole === 4;
  }

  //updatePortfolioState(policy) {
  //  this.portfolioService.updatePortfolioState(policy)
  //    .subscribe(res => {
  //      this.policy.lock = this.lockPortfolioByState();
  //    });
  //}

  onDateSelect($event) {
    let agreementDate: Date = new Date($event.year, $event.month - 1 , $event.day);
    this.gestion.dateAgreement = agreementDate;
  }

  addFieldValue() {

    this.idUser = this._authenService.currentUserValue.idUser;
    this.gestion.fkIdUser = this.idUser;
    this.gestion.fkIdPortfolio = this.policy.idPortfolio;
    this.gestion.fkNameUser = this._authenService.currentUserValue.userName;
    this.gestion.managementDate = new Date();

    let replay = this.f.replayManagement.value;

    if (typeof replay == "undefined") {
      replay = false;
    }

    //if (replay == true) {
      //this.gestion.lock = this.lockPortfolioByResult();
      //this.disableFields = this.lockPortfolioByResult();
      //this.updateTables.emit(this.gestion);
    
    //} else {
    //  this.policy.managementList.push(this.gestion);
    //  this.policy.lock = this.lockPortfolioByResult();
    //}

    console.log(this.gestion);

    this.portfolioService.saveManagementPortfolio(this.gestion, replay)
      .subscribe(res => {
        this.gestion = new CollectionManagement();
        this.updateTables.emit(this.policy.idPortfolio);
      },
        err => {
          this.error = err;
          this.cleanError();
        });

  }

  hide(hiddenText: any, field: any) {

    if (hiddenText.hidden) {
      hiddenText.removeAttribute('hidden');
      if (field.managementObservation.length > 100) hiddenText.previousSibling.classList.remove('dots');
    } else {
      hiddenText.setAttribute('hidden', 'hidden');
      if (field.managementObservation.length > 100) hiddenText.previousSibling.classList.add('dots');
    }
   
  }

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }

  lockPortfolioByResult() {
    let lock = this.collectionManagementResults.find(u => u.idCollectionManagementResult == this.gestion.fkIdManagementResult).cancelPortfolio || this.collectionManagementResults.find(u => u.idCollectionManagementResult == this.gestion.fkIdManagementResult).blockManagement;
    if (lock) {
      return true;
    }
    return false;
  }

//  lockPortfolioByState() {
//    let lock = this.portfolioStates.find(u => u.idPortfolioState == this.policy.fkIdPortfolioState).blockPortfolio;
//    if (lock) {
//      return true;
//    }
//    return false;
//  }
}
